import SwapBlock from './SwapBlock.vue'

export default SwapBlock
